<template>
  <div class="father">
    <div class="title">
      <span class="demonstration">通过日期查询范围内的操作记录</span>
      <el-date-picker
        v-model="time1"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="timeChange"
      >
      </el-date-picker>
    </div>
    <div v-if="logList.length == 0" class="log-body log-body-empty ">
      该时间段未发现数据
    </div>
    <div v-else class="log-body">
      <div style="height:20px"></div>
      <el-scrollbar
        class="scroll"
        wrapStyle="overflow-x:hidden;"
        style="width: 100%;"
        :style="`height:${scroll_height}px`"
      >
        <div v-for="(items, index) in logList" :key="index">
          <div class="scroll-title">{{ items.date }}</div>
          <div v-for="(item, i) in items.children" :key="i" class="log-item">
            <div class="item-top">
              <div class="top-title">
                <span class="item-span">{{ item.com_no }}</span>
                <span class="item-span">用户：</span>{{ item.oper_id }}
              </div>

              <span class="item-span " style="margin-left:20px;">详情：</span>
              <span class="itm-span-overflow">{{ item.message }}</span>
              <span class="itm-span-delete" @click="deleteLog(item.com_no)"
                >删除</span
              >
            </div>
            <div class="item-bottom">{{ item.oper_time }}</div>
          </div>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script>
import { serviceLogQuery, serviceLogDelete } from "@/api/service.js";
export default {
  name: "log",
  data() {
    return {
      time1: [],
      logList: [],
      scroll_height: ""
    };
  },
  computed: {
    editableTabsValue() {
      return this.$store.state.home.editableTabsValue;
    },
    mainH() {
      return this.$store.state.resolution.mainH;
    },
    innerWH() {
      return this.$store.state.resolution.innerWH;
    }
  },
  watch: {
    mainH: {
      handler(newH, oldH) {
        this.scroll_height = newH - 100;
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    this.time1 = [start, end];
    this.getLogList(start, end);
    this.logList = [];
  },
  methods: {
    async timeChange(e) {
      const [start_time, expire_time] = e;
      this.getLogList(start_time, expire_time);
    },
    async getLogList(start_time, expire_time) {
      this.logList = [];
      const res = await serviceLogQuery({ start_time, expire_time });

      if (this.testR(res)) {
        const logList = res.data.resp_data.log;
        var arr = [];
        for (let i = 0; i < logList.length; i++) {
          const mstr = `${logList[i].oper_time.split("/")[0]}/${
            logList[i].oper_time.split("/")[1]
          }`;
          if (!arr.includes(mstr)) {
            arr.push(mstr);
          }
        }
        console.log(arr);
        for (let j = 0; j < arr.length; j++) {
          this.logList.push({
            date: `${arr[j].split("/")[0]}年${arr[j].split("/")[1]}月`,
            children: []
          });
          for (let i = 0; i < logList.length; i++) {
            if (logList[i].oper_time.slice(0, arr[j].length) == arr[j]) {
              this.logList[j].children.push(logList[i]);
            }
          }
        }
        console.log("logList------------------", this.logList);
      }
    },
    deleteLog(com_no) {
      serviceLogDelete(com_no).then(res => {
        if (res.data && res.data.resp_data && res.data.resp_data.desc == "OK") {
          this.successMessage("记录删除成功！");
          this.getLogList(this.time1[0], this.time1[1]);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.father {
  flex-direction: column;
  height: 100%;
}
.demonstration {
  width: auto;
  padding: 0 20px;
}
.title {
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  // background-color: pink;
  // padding: 10px;
}
.log-body {
  width: 100%;
  // background-color: pink;
  padding: 0 20px;
  .scroll {
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    -webkit-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    border-radius: 10px;
    // background-color: #55ff00;
  }
  .scroll-title {
    display: block;
    font-size: 30px;
    font-weight: 700;
    color: #f56c6c;

    margin-left: 20px;
    width: 250px;
    text-align: justify;
    display: inline-block;
    text-align: justify;
    text-align-last: justify;
    text-justify: distribute-all-lines; /*这行必加，兼容ie浏览器*/
  }
  .log-item {
    height: 80px;
    // background-color: #fff;
    margin: 5px 0;
    padding: 5px 20px;
    // background-color: rgb(0, 38, 119);
    // color: #fff;
    background-color: rgba(0, 0, 0, 0.04);
    border-radius: 10px;

    font-size: 20px;

    .item-span {
      display: inline-block;
      width: 60px;
      font-size: 16px;
      color: #409eff;
      font-weight: 700;
      // background-color: #fff;
    }
    .itm-span-overflow {
      width: calc(100% - 250px);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .itm-span-delete {
      color: red;
      font-size: 18px;
      cursor: pointer;
      width: auto;
      min-width: 60px;
      text-align: center;
    }
    .item-top {
      height: 40px;
      display: flex;
      align-items: center;
      .top-title {
        width: auto;
        min-width: 250px;
      }
    }
    .item-bottom {
      height: 40px;
      width: 100%;
      text-align: right;
      color: #909399;
      font-size: 16px;
    }
  }
}
.log-body-empty {
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-size: 30px;
  color: #f56c6c;
}
</style>
